import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import React from 'react'

const ServiceTypeDeleteConfimationDialog = ({
  open, setOpen, onSubmit
}) => {
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
    >
      <DialogTitle>Confirm Removal</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to remove this service type?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ mr: 2, pb: 3 }}>
        <Button
          onClick={() => setOpen(false)}
          size="small"
          variant="outlined"
        >
          Cancel
        </Button>
        <Button
          onClick={onSubmit}
          size="small"
          color="error"
          variant="outlined"
        >
          Remove
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ServiceTypeDeleteConfimationDialog